<div
  class="ui vertical basic segment"
  style="padding: 30px"
  [ngClass]="{ loading: pendingArr?.length }"
>
  <h3 class="ui primary header">
    {{ modal.context.title }}
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div class="content">
    <div class="scroll-wrapper ui basic segment">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
        <esl-message-toast
          [(message)]="success"
          [messageType]="success"
        ></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
      <!--Laboratory form  -->
      <form
        class="ui form"
        [formGroup]="createProcurementItem"
        name="createProcurementItem"
        (ngSubmit)="onSubmit()"
      >
        <div class="field" [ngClass]="displayFieldCss('description')">
          <label class="required">Description</label>
          <input
            formControlName="description"
            type="text"
            placeholder="Payment of Tender Fees"
          />
          <app-field-error-display
            [displayError]="isFieldValid('description')"
            errorMsg="Please Description"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('description')?.valid &&
              createProcurementItem.get('description')?.touched
            "
          ></div>
        </div>
        <div class="field" [ngClass]="displayFieldCss('amount')">
          <label class="required">Amount</label>
          <input formControlName="amount" [disabled]="disabled" type="text" />
          <app-field-error-display
            [displayError]="isFieldValid('amount')"
            errorMsg="Please enter Amount"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('amount')?.valid &&
              createProcurementItem.get('amount')?.touched
            "
          ></div>
        </div>
        <div class="field" [ngClass]="displayFieldCss('payerName')">
          <label class="required">Payer's Name</label>
          <textarea
            formControlName="payerName"
            rows="2"
            placeholder="Alimi Brothers and Sons"
          ></textarea>
          <app-field-error-display
            [displayError]="isFieldValid('payerName')"
            errorMsg="Please enter Payer name"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('payerName')?.valid &&
              createProcurementItem.get('payerName')?.touched
            "
          ></div>
        </div>
        <div class="field" [ngClass]="displayFieldCss('payerAddress')">
          <label class="required">Payer's Address</label>
          <textarea
            formControlName="payerAddress"
            rows="2"
            placeholder="Enter business address"
          ></textarea>
          <app-field-error-display
            [displayError]="isFieldValid('payerAddress')"
            errorMsg="Please enter business Address"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('payerAddress')?.valid &&
              createProcurementItem.get('payerAddress')?.touched
            "
          ></div>
        </div>
        <div class="field" [ngClass]="displayFieldCss('payerEmail')">
          <label class="required">Email Address</label>
          <textarea
            formControlName="payerEmail"
            rows="2"
            placeholder="alimi@gmail.com"
          ></textarea>
          <app-field-error-display
            [displayError]="isFieldValid('payerEmail')"
            errorMsg="Please enter email address"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('payerEmail')?.valid &&
              createProcurementItem.get('payerEmail')?.touched
            "
          ></div>
        </div>
        <div class="field" [ngClass]="displayFieldCss('payerPhone')">
          <label class="required">Phone Number</label>
          <textarea
            formControlName="payerPhone"
            rows="2"
            placeholder="0808837373733"
          ></textarea>
          <app-field-error-display
            [displayError]="isFieldValid('payerPhone')"
            errorMsg="Please enter Phone Number"
          >
          </app-field-error-display>
          <div
            class="data-error"
            *ngIf="
              !createProcurementItem.get('payerPhone')?.valid &&
              createProcurementItem.get('payerPhone')?.touched
            "
          ></div>
        </div>
      </form>
    </div>
  </div>

  <div class="actions" style="margin-top: 40px">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ yellow: pendingArr?.length }"
      [disabled]="!createProcurementItem.valid"
      (click)="tenderPayment()"
      autofocus
    >
      Proceed
    </button>
  </div>
</div>
